export * from "./e-theme-default-ja-jp-shape-input";
